<template>
  <div class="resetPassword">
    <!-- 表单部分 -->
    <van-cell-group class="cell_group">
      <van-form validate-first @failed="onFailed" @submit="onSubmit">
        <!-- 通过 pattern 进行正则校验 -->
        <div class="login_label">忘记密码</div>
        <van-field
          v-model="username"
          name="username"
          placeholder="请输入手机号"
          scroll-to-error
          clearable
          :rules="[
            {
              pattern: mobilePattern,
              message: '手机号格式错误',
              required: true,
            },
          ]"
        />
        <van-field
          v-model="validateCode"
          name="validateCode"
          placeholder="请输入较验码"
          clearable
          :rules="[
            {
              required: true,
            },
          ]"
        >
          <div slot="button">
            <van-image @click="toggleCode" width="80" :src="verificationImg" />
          </div>
        </van-field>

        <van-field
          v-model="smsCode"
          :rules="[
            {
              message: '短信校验码不能为空!',
              required: true,
            },
          ]"
          clearable
          name="smsCode"
          placeholder="请输入验证码"
        >
          <div slot="button">
            <div v-if="showCountDown">
              <van-count-down
                :time="smsTime"
                format="ss"
                @finish="countDownFinish"
              />
            </div>
            <div v-else class="smsCodeText" v-on:click="sendSmsCode">
              获取验证码
            </div>
          </div>
        </van-field>
        <!-- 登陆按钮 -->
        <div class="btn-wrap" style="margin-top: 16px">
          <van-button round block type="info" class="btn" native-type="submit"
            >提交</van-button
          >
        </div>
      </van-form>
    </van-cell-group>
  </div>
</template>

<script>
import "../../assets/css/resetPassword.less";
import { verificationCode, sendSmsCode, checkForgetPassword } from "@/api/user";
import { Toast } from "vant";
// import axios from "axios";

export default {
  name: "ForgetPassword",
  data() {
    return {
      username: "",
      password: "",

      mobilePattern: /^[1]([3-9])[0-9]{9}$/, //正则匹配手机号码
      validateCode: "", //图形验证码
      validateResult: false, //图形验证码验证结果
      verificationImg: "",

      smsCode: "",
      smsTime: 60 * 1000,
      showCountDown: false, //是否显示倒计时
      maxDiffTime: 60 * 1000, // 发送短信的间隔
    };
  },
  created() {
    this.loadComments();
  },
  methods: {
    loadComments() {
      let _this = this;
      var num = Math.ceil(Math.random() * 1000);
      _this.verificationImg = "/mem/verificationCode/validateCode?" + num;

      _this.getCountDownTime();
    },
    //获取时间倒计时
    getCountDownTime() {
      let _this = this;
      let st = sessionStorage.getItem("sendTime");
      let sendTime = st ? parseInt(st) : 0;
      const diffTime = new Date().getTime() - sendTime;
      if (diffTime >= this.maxDiffTime) {
        _this.showCountDown = false;
      } else {
        _this.smsTime = _this.smsTime - diffTime;
        _this.showCountDown = true;
      }
    },
    //点击验证码
    toggleCode() {
      var num = Math.ceil(Math.random() * 1000); //生成一个随机数（防止缓存）
      this.verificationImg = "/mem/verificationCode/validateCode?" + num;
    },

    //发送短信验证码
    sendSmsCode() {
      let _this = this;
      verificationCode(_this.validateCode).then((resp) => {
        if (resp.data.code == 200) {
          sendSmsCode(_this.username, 0);
          _this.showCountDown = true;
        } else {
          Toast("图形验证码错误！");
        }
      });
      sessionStorage.setItem("sendTime", new Date().getTime());
    },
    onFailed(errorInfo) {
      console.log("failed", errorInfo);
    },
    //表单提交
    onSubmit(values) {
      let _this = this;

      let param = {
        code: values.smsCode,
        mobile: values.username,
      };
      checkForgetPassword(param).then((resp) => {
        if (resp.data.code == "0000") {
          _this.showCountDown = true;
          _this.smsTime = 60 * 1000;
          sessionStorage.setItem("forgetMobile", param.mobile);
          sessionStorage.setItem("forgetCode", param.code);
          _this.$router.push("/resetPassword");
        } else {
          Toast(resp.data.msg);
        }
      });
    },
    //改变计时状态
    countDownFinish() {
      this.showCountDown = false;
    },
  },
};
</script>


